import { render } from "./AsideNew.vue?vue&type=template&id=068b02c3&ts=true"
import script from "./AsideNew.vue?vue&type=script&lang=ts"
export * from "./AsideNew.vue?vue&type=script&lang=ts"

import "./AsideNew.vue?vue&type=style&index=0&id=068b02c3&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__